<template>
  <div class="animated fadeIn">
  	<h2 class="text-center">Welcome to Admin Panel</h2>
  </div>
</template>

<script>
export default {

}	
</script>